module.exports = __webpack_public_path__ + "static/media/cases_3d_02b.b450ca56.jpg";